import * as $ from 'jquery';
import "../../lib/jquery.magnific-popup.js";
import * as Swiper from 'swiper/dist/js/swiper.min';

declare var s7viewers: any;
//declare var addthis: any;

const enum URLs {
	IMAGE_BASE_URL = '//images.pfisterfaucets.com/is/image/',
	SCENE7_VIDEO_BASE_URL = '//s7d1.scene7.com/is/content/',
	SKINS_BASE_URL = '//s7d1.scene7.com/skins/',
	DOWNLOAD_IMAGE_URL = '/product/downloadimage?imageurl='
}

const enum CONFIG {
	DEFAULT_SKIN = 'CONFIG.DEFAULT_SKIN'
}

namespace PFF.controllers.modal {
	function getParameterByName(name, url?) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	//strip out empty items in array
	function cleanArray(actual) {
		var newArray = new Array();
		for (var i = 0; i < actual.length; i++) {
			if (actual[i]) {
				newArray.push(actual[i]);
			}
		}
		return newArray;
	}

	function checkForBeginningAndEnd() {
		let $selectedSlide = $('.swiper-slide-selected');
		let $nextArrow = $('.js-next-arrow');
		let $prevArrow = $('.js-prev-arrow');
		(!$selectedSlide.next('.swiper-slide').length) ? $nextArrow.addClass('disabled') : $nextArrow.removeClass('disabled');
		(!$selectedSlide.prev('.swiper-slide').length) ? $prevArrow.addClass('disabled') : $prevArrow.removeClass('disabled');
	}

	function passIDBuildList() {
		// here were grabbing query string param values that get passed through so we can work with the data
		// console.log(document.location.href);

		var queryStringValues = getParameterByName('ids');
		var selectedItemID = getParameterByName('selectedItem');
		// console.log(selectedItemID);

		/*console.log(queryStringValues);
		console.log(selectedItemID);*/

		//performing a split on the ids coming through
		var splitValues = queryStringValues.split(',');
		var joinedValues = splitValues.join(',');

		//perform our string splits to get different segments of incoming data

		var imageIds = joinedValues.split('vignetteids:')[0] != null ? joinedValues.split('vignetteids:')[0] : "";
		var galleryimageIds = joinedValues.split('vignetteids:')[0] != null ? joinedValues.split('vignetteids:')[0] : '';
		var vignetteSegment = joinedValues.split('vignetteids:')[1] != null ? joinedValues.split('vignetteids:')[1] : '';
		var vignetteimageIds = vignetteSegment.split('roomids:')[0] != null ? vignetteSegment.split('roomids:')[0] : '';
		var roomSegment = joinedValues.split('roomids:')[1] != null ? joinedValues.split('roomids:')[1] : '';
		var roomimageIds = roomSegment.split('lifestyleids:')[0] != null ? roomSegment.split('lifestyleids:')[0] : '';		
		var lifestyleSegment = joinedValues.split('lifestyleids:')[1] != null ? joinedValues.split('lifestyleids:')[1] : '';
		var lifestyleimageIds = lifestyleSegment.split('product360ids:')[0] != null ? lifestyleSegment.split('product360ids:')[0] : '';		
		var product360Segment = joinedValues.split('product360ids:')[1] != null ? joinedValues.split('product360ids:')[1] : '';
		var product360videoIds = product360Segment.split('supplementaryids:')[0] != null ? product360Segment.split('supplementaryids:')[0] : '';		
		var supplementarySegment = joinedValues.split('supplementaryids:')[1] != null ? joinedValues.split('supplementaryids:')[1] : '';
		var supplementaryimageIds = supplementarySegment.split('threesixtyids:')[0] != null ? supplementarySegment.split('threesixtyids:')[0] : '';		
		var threesixtySegment = joinedValues.split('threesixtyids:')[1] != null ? joinedValues.split('threesixtyids:')[1] : '';
		var threesixtyIds = threesixtySegment.split('roomremids:')[0] != null ? threesixtySegment.split('roomremids:')[0] : '';	
		var roomremSegment = joinedValues.split('roomremids:')[1] != null ? joinedValues.split('roomremids:')[1] : '';
		var roomremimageIds = roomremSegment.split('vignetteremids:')[0] != null ? roomremSegment.split('vignetteremids:')[0] : '';		
		var vignetteremSegment = joinedValues.split('vignetteremids:')[1] != null ? joinedValues.split('vignetteremids:')[1] : '';
		var vignetteremimageIds = vignetteremSegment.split('clippedids:')[0] != null ? vignetteremSegment.split('clippedids:')[0] : '';		
		var clippedSegment = joinedValues.split('clippedids:')[1] != null ? joinedValues.split('clippedids:')[1] : '';
		var clippedimageIds = clippedSegment.split('marketingids:')[0] != null ? clippedSegment.split('marketingids:')[0] : '';
		var marketingvideoIds = clippedSegment.split('marketingids:')[1] != null ? clippedSegment.split('marketingids:')[1] : '';
		


		//concatenate and check for length of combined types
		var concatenatedString = galleryimageIds.concat(vignetteimageIds, roomimageIds, lifestyleimageIds, product360videoIds, supplementaryimageIds, threesixtyIds, roomremimageIds, vignetteremimageIds, clippedimageIds, marketingvideoIds);
		var itemsLength = cleanArray(concatenatedString.split(',')).length;

		//create objects from specific segments
		var allImagesArray = cleanArray(concatenatedString.split(','));
		var galleryimagesArray = cleanArray(galleryimageIds.split(','));
		var vignetteimagesArray = cleanArray(vignetteimageIds.split(','));
		var roomimagesArray = cleanArray(roomimageIds.split(','));
		var lifestyleimagesArray = cleanArray(lifestyleimageIds.split(','));
		var product360videosArray = cleanArray(product360videoIds.split(','));
		var supplementaryimagesArray = cleanArray(supplementaryimageIds.split(','));
		var threesixtysArray = cleanArray(threesixtyIds.split(','));
		var roomremimagesArray = cleanArray(roomremimageIds.split(','));
		var vignetteremimagesArray = cleanArray(vignetteremimageIds.split(','));
		var clippedimagesArray = cleanArray(clippedimageIds.split(','));
		var marketingvideosArray = cleanArray(marketingvideoIds.split(','));
		
		//need to seperate out mutliple id from single id so split does not fail if only 1 id.
		var properID = selectedItemID != null ? selectedItemID : allImagesArray[0];
		var isSingleID = itemsLength < 2 || getParameterByName('singleImage');
		let $body = $('body');

		// full image url
		if(galleryimagesArray.length) {
			var fullImageUrl = URLs.IMAGE_BASE_URL + properID + '?$pfZoomableImageLarge$';
		}

		// console.log(fullImageUrl);
		//setup other vars
		var $carousel = $('.js-product-carousel');

		//check for a query param indicating that there is only 1 id coming through and add class so we can style differently
		if (isSingleID || itemsLength < 2) {
			$('body').addClass('single-element');
		}
		if(galleryimagesArray.length == 2)
		{
           if(galleryimagesArray[0] == galleryimagesArray[1])
		   $('body').addClass('same-slide');
		}

		//if there is more than one id coming through then loop through the ids and add the image to carousel, if not we dont do this.
		if (!isSingleID) {
			if(galleryimagesArray.length){
				$.each(galleryimagesArray, function (i) {
				var theID = galleryimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(vignetteimagesArray.length){
				$.each(vignetteimagesArray, function (i) {
				var theID = vignetteimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(roomimagesArray.length){
				$.each(roomimagesArray, function (i) {
				var theID = roomimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(lifestyleimagesArray.length){
				$.each(lifestyleimagesArray, function (i) {
				var theID = lifestyleimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(product360videosArray.length){
				$.each(product360videosArray, function (i) {
				var theID = product360videosArray[i];
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link-youtube product-carousel__link">
						<img src="https://img.youtube.com/vi/${theID}/mqdefault.jpg" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(supplementaryimagesArray.length){
				$.each(supplementaryimagesArray, function (i) {
				var theID = supplementaryimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(threesixtysArray.length){
				$.each(threesixtysArray, function (i) {
				var theID = threesixtysArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(roomremimagesArray.length){
				$.each(roomremimagesArray, function (i) {
				var theID = roomremimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(vignetteremimagesArray.length){
				$.each(vignetteremimagesArray, function (i) {
				var theID = vignetteremimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
			if(clippedimagesArray.length){
				$.each(clippedimagesArray, function (i) {
				var theID = clippedimagesArray[i];
				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$pfModalThumb$" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}			
			if(marketingvideosArray.length){
				$.each(marketingvideosArray, function (i) {
				var theID = marketingvideosArray[i];
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link-youtube product-carousel__link">
						<img src="https://img.youtube.com/vi/${theID}/mqdefault.jpg" class="product-carousel__img">
					</a>
				</div>`).appendTo($carousel);
				});
			}
		}
			

		// Swiper seems to expand slides fill the available space, so if there are only two we'll have to make the carousel shorter
		if (itemsLength < 3) {
			$('.swiper-container').addClass('swiper-container--short');
		}

		//initialize swiper with the current slide set to 0 if there is no selected item being passed through a query param
		//OR if selected item is being passed through we set the initial slide to the selected items parent index value

		let slidesPerView = Math.min( itemsLength, 3 );
		//let centeredSlides = (itemsLength >= 3);

		var mySwiper;

		if (!isSingleID) {
			mySwiper = new Swiper('.swiper-container', {
				// Optional parameters
				direction: (window.innerWidth >= 768) ? 'vertical' : 'horizontal',
				slidesPerView: slidesPerView,
				spaceBetween: 20,
				init: false,
				initialSlide: selectedItemID != null ? $(`a[data-id="${selectedItemID}"]`).parent().index() : 0,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}
			});
		}

		if (!isSingleID) {
			mySwiper.on('init', function () {
				setTimeout(function(){
					if(selectedItemID != null ) {
						mySwiper.activeIndex = $(`a[data-id="${selectedItemID}"]:first`).parent().index();
					}
					if(mySwiper.activeIndex == -1) {
						mySwiper.activeIndex = 0;
					}

					$('.swiper-slide').removeClass('swiper-slide-selected');
					$(mySwiper.slides[mySwiper.activeIndex]).addClass("swiper-slide-selected");
					$(mySwiper.slides[mySwiper.activeIndex]).find('a[class^="js-carousel-link"]').trigger("click");
					// console.log(mySwiper.activeIndex);
				}, 300);
			});
		}

		// Set the download link to match the large image
		$('.icons-block__link').eq(0).attr('href', fullImageUrl);

		// Set the share link to set up for Add This for the large image
	//	$('.addthis_button_compact').attr({
	//		href: 'http://api.addthis.com/oexchange/0.8/offer?url=' + fullImageUrl
	//	});

		if(allImagesArray.length) {
			/**
			 * https://stackoverflow.com/questions/15367134/change-addthis-url-dynamically-with-jquery
			 * This page has information on this element of the api I could not find this on the addthis site
			 */
		//	addthis.update('share', 'url', fullImageUrl);
		//	addthis.update('share', 'title', 'Pfister Faucets');
		//	addthis.update('share', 'media', fullImageUrl);
			//setup the initial scene7 Zoom Viewer.
			let s7basiczoom_div = new s7viewers.BasicZoomViewer({
				"containerId": "s7basiczoom_div",
				"params": {
					"asset": properID,
					"serverurl": URLs.IMAGE_BASE_URL,
					"contenturl": URLs.SKINS_BASE_URL,
					"config": CONFIG.DEFAULT_SKIN
				}
			}).init();

			// console.log(properID);
		}

		if (mySwiper) {
			mySwiper.init();

			mySwiper.on('resize', function(){
				mySwiper.update();
			});
		}

		//When we click on a carousel item link in the modal were reinitializing the BasicZoomViewer with the correct asset id
		$body.on('click', '.js-carousel-link', function (e) {
			$('#s7viewer').remove();
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			$('.icons-list').removeAttr('style');
			$(`<div id="s7basiczoom_div" />`).prependTo($(".product-carousel__right-col"));
			var s7basiczoom_div = new s7viewers.BasicZoomViewer();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			var idOfElement = $(this).data('id');
			var zoomViewerParent = $('#s7basiczoom_div');
			e.preventDefault();
			zoomViewerParent.empty();
			checkForBeginningAndEnd();

			var fullImageUrl = URLs.IMAGE_BASE_URL + idOfElement + '?$pfZoomableImageLarge$';

			// Update the download link to match the large image
			//$('.icons-block__link').eq(0).attr('href', fullImageUrl);
			$('.icons-block__link').eq(0).attr('href', URLs.DOWNLOAD_IMAGE_URL + URLs.IMAGE_BASE_URL + idOfElement + "&imagename="+ idOfElement);

			// Set the share link to set up for Add This for the large image
			//$('.addthis_button_compact').attr({
			//	href: 'http://api.addthis.com/oexchange/0.8/offer?url=' + fullImageUrl
			//});

			// console.log(`full image url is: ${fullImageUrl}`);

			/**
			 * https://stackoverflow.com/questions/15367134/change-addthis-url-dynamically-with-jquery
			 * This page has information on this element of the api I could not find this on the addthis site
			 */
		//	addthis.update('share', 'url', fullImageUrl);
		//	addthis.update('share', 'title', 'Pfister Faucets');
		//	addthis.update('share', 'media', fullImageUrl);

			var s7basiczoom_div = new s7viewers.BasicZoomViewer({
				"containerId": "s7basiczoom_div",
				"params": {
					"asset": idOfElement,
					"serverurl": URLs.IMAGE_BASE_URL,
					"contenturl": URLs.SKINS_BASE_URL,
					"config": CONFIG.DEFAULT_SKIN
				}
			}).init();
		});

		$body.on('click', '.js-prev-arrow', function(e){
			let $selectedSlide = $('.swiper-slide-selected');
			if($selectedSlide.prev('.swiper-slide').length) {
				$('.js-next-arrow').removeClass('disabled');
				$selectedSlide.prev('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
			} else {
				$(this).addClass('disabled');
			}
			e.preventDefault();
		});

		$body.on('click', '.js-next-arrow', function(e){
			let $selectedSlide = $('.swiper-slide-selected');
			if($selectedSlide.next('.swiper-slide').length) {
				$('.js-prev-arrow').removeClass('disabled');
				$selectedSlide.next('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
			} else {
				$(this).addClass('disabled');
			}
			e.preventDefault();
		});

		$body.on('click', '.js-carousel-link-youtube', function (e) {
			$('#s7viewer').remove();
			var $this = $(this);
			var $youtubeID = $this.data('id');
			$('.icons-list').hide();
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			e.preventDefault();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			$(`<div class="embed-responsive embed-responsive-16by9"><iframe width="845" height="476" src="https://www.youtube.com/embed/${$youtubeID}?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`).prependTo($(".product-carousel__right-col"));
			checkForBeginningAndEnd();
		});

		$body.on('click', '.js-carousel-link-scene7', function (e) {
			$('#s7viewer').remove();
			var $this = $(this);
			$('.icons-list').hide();
			var $scene7ID = $this.data('id');
			var encodedID = $scene7ID.replace('-', '%2D').replace(' ', '%20');
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			e.preventDefault();
			$(`<div class="embed-responsive embed-responsive-16by9"><video width="845" height="476" id="scene7Vid" controls autoplay>
                <source src="${URLs.SCENE7_VIDEO_BASE_URL}/${encodedID}" type="video/mp4">
					Your browser does not support the video tag.
				</video></div>`).prependTo($(".product-carousel__right-col"));
			$('#scene7Vid').get(0).play();
			checkForBeginningAndEnd();
		});

		$body.on('click', '.js-carousel-link-threesixty', function (e) {
			$('#s7basiczoom_div').remove();
			$('#s7viewer').remove();
			$('.embed-responsive').remove();
			$(`<div id="s7viewer" />`).prependTo($(".product-carousel__right-col"));
			var spinViewer = new s7viewers.SpinViewer();
			var $this = $(this);
			$('.icons-list').hide();
			var $theeSixtyID = $this.data('id');
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');

			var spinViewerParent = $('#s7viewer');

			e.preventDefault();
			spinViewerParent.empty();

			var spinViewer = new s7viewers.SpinViewer({
				"containerId":"s7viewer",
				"params":{
					"asset": $theeSixtyID,
					"serverurl": URLs.IMAGE_BASE_URL,
				}
			}).init();
			checkForBeginningAndEnd();
		});

		setTimeout(function(){
			$('.js-load-indicator').removeClass('state-loading');
			$('.js-load-indicator-cover').addClass('state-hidden');
		}, 1200);
	}

	function addThisHooks(){
		let closeButton = $('button.mfp-close',parent.document);
		$('body').on('click', '.js-addthis-share', function(e){
			$('body').off('click', '.at-expanded-menu-close');
			setTimeout(function(){
				closeButton.addClass('hidden');
				$('body').on('click', '.at-expanded-menu-close', function(){
					closeButton.removeClass('hidden');
				})
			}, 20);
		});
	}

	export function init() {
		passIDBuildList();
		addThisHooks();
	}
}

PFF.controllers.modal.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/modal.ts